import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ToolBlock from "../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import SearchBlockRHF from "../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import TableComponent from "../../components/GeneralComponents/SearchTable/tableComponent";

import { getDataApplicantBySearchParams } from "../../redux/issuingCertificatesReducer/actionsIssuingCertificates";
import { SEARCH_ISSUING_CERTIFICATES_APPLICANT_COLUMNS } from "../../components/GeneralComponents/SearchTable/TablesColumns";

import {
  options,
  setOptionsSections,
  setOptionsProgramId,
} from "../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./formSearchApplicant.module.css";

export default function FormSearchApplicant() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    section: 0,
    programId: 0,
  });

  const dataForTableApplicant = useSelector((state) => {
    const { issuingCertificatesReducer } = state;
    return issuingCertificatesReducer.dataApplicants;
  });

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };
  const handleSearch = () => {
    dispatch(getDataApplicantBySearchParams(searchParams, 0));
    setSelectedPage(0);
    setSelectedRowData(null);
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        birthDate: "",
        section: 0,
        programId: 0,
      }),
    );
    dispatch(
      getDataApplicantBySearchParams(
        {
          surname: "",
          name: "",
          midname: "",
          birthDate: "",
          section: 0,
          programId: 0,
        },
        0,
      ),
    );
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getDataApplicantBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(
        dictionaryReducer.gimsSections,
        options.inputsApplicationSearch.key,
      );
    }
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      const validLib = dictionaryReducer.trainingProgramLibrary.map((item) => {
        return {
          value: item.id,
          label: item.sign,
          key: "programId",
        };
      });
      setOptionsProgramId(
        validLib,
        options.inputsApplicationSearch.key,
        "programId",
      );
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(
        dictionaryReducer.gimsSections,
        options.inputsApplicationSearch.key,
      );
    }
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      const validLib = dictionaryReducer.trainingProgramLibrary.map((item) => {
        return {
          value: item.id,
          label: item.sign,
          key: "programId",
        };
      });
      setOptionsProgramId(
        validLib,
        options.inputsApplicationSearch.key,
        "programId",
      );
    }
  }, []);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <p className={styles["back-block"]} onClick={() => navigate(-1)}>
        <span className={styles["back-icon"]}></span>
        <p className={styles["back-text"]}>{"Вернуться к заявлениям"}</p>
      </p>
      <SearchBlockRHF
        options={options.inputsApplicationSearch}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        id={selectedRowData?.id}
        addBtnDisIn={!selectedRowData?.id}
        personType={selectedRowData?.programId}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={SEARCH_ISSUING_CERTIFICATES_APPLICANT_COLUMNS}
        data={dataForTableApplicant.content || []}
        totalPages={dataForTableApplicant.totalPages || 0}
        totalElements={dataForTableApplicant.totalElements || 0}
        selectedPage={selectedPage}
      />
    </div>
  );
}
